<template>
  <el-select
    class="user-selector"
    :value="userId"
    @input="handleChangeUser"
    placeholder="เลือกลูกค้า"
    clearable
    filterable
    remote
    reserve-keyword
    :disabled="disabled"
    :remote-method="handleRemoteMethod"
    :loading="loading"
  >
    <el-option
      v-for="item in userOptions"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <div class="user-option">
        <div class="name">{{ item.name }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Select, Option } from "element-ui";
import { debounce } from "@/lib/util";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "initialUsers", "disabled"],
  data() {
    const users = [];
    const loading = false;

    return {
      users,
      loading
    };
  },
  computed: {
    userOptions() {
      return this.users.map(user => {
        const { user_id, user_profile } = user;
        const name = `${user_profile.first_name} ${user_profile.last_name}`;

        return {
          id: user_id,
          name
        };
      });
    },
    userId() {
      if (!this.value) {
        return null;
      }

      return this.value.user_id;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupUsers();
    },
    async setupUsers() {
      const response = await this.fetchUsers();
      const users = response.users.map(item => {
        const user = item.user ? item.user : item;

        return user;
      })

      this.users = users;
    },
    async fetchUsers() {
      if (this.initialUsers) {
        return Promise.resolve(this.initialUsers);
      }

      const response = await baanRueJaiClient.admin.users.list();

      return response.data.result;
    },
    handleChangeUser(userId) {
      const user = this.users.find(user => user.user_id === +userId);

      this.$emit("input", user);
    },
    handleRemoteMethod: debounce(async function(query) {
      if (query === "") {
        this.users = [];
        return;
      }

      this.loading = true;
      const [firstName, lastName] = query.split(" ");
      const response = await baanRueJaiClient.admin.users.list({
        firstName,
        lastName
      });

      const users = response.data.result.users.map(item => {
        const user = item.user ? item.user : item;

        return user;
      })

      this.users = users;
      this.loading = false;
    }, 1)
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.user-selector {
  width: 100%;
}

.user-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/UserSelect.vue